import api from "./api";

export const getProvinces = async () => {
  const { data } = await api.get("/api/v1/geography/provinces", { skipAuth: true });
  return data?.items || data || [];
};

export const getDistrictsByProvince = async (provinceId) => {
  if (!provinceId) return [];
  const { data } = await api.get(
    `/api/v1/geography/provinces/${provinceId}/districts`,
    { skipAuth: true }
  );
  return data?.items || data || [];
};

export const getSubdistrictsByDistrict = async (districtId) => {
  if (!districtId) return [];
  const { data } = await api.get(
    `/api/v1/geography/districts/${districtId}/subdistricts`,
    { skipAuth: true }
  );
  return data?.items || data || [];
};

export const getSubdistrictsByZipcode = async (zipcode) => {
  const code = (zipcode || "").toString().trim();
  if (!code) return [];

  const { data } = await api.get(
    "/api/v1/geography/subdistricts/by-zipcode",
    {
      params: { zipcode: code },
      skipAuth: true,
    }
  );

  return data?.items || data || [];
};

export const getNearbyRiders = async (lat, lng, radiusMeters, serviceTypeId, vehicleTypeId) => {
  const { data } = await api.get("/api/v1/geography/nearby-riders", {
    params: {
      lat, lng,
      ...(radiusMeters ? { radius: radiusMeters } : {}),
      ...(serviceTypeId ? { serviceTypeId } : {}),
      ...(vehicleTypeId ? { vehicleTypeId } : {}),
    },
  });
  return data?.items || [];
};

export const searchAddress = async (q) => {
  if (!q || q.trim().length < 2) return [];
  const { data } = await api.get("/api/v1/geography/search", {
    params: { q: q.trim() },
    skipAuth: true,
  });
  return data?.items || data || [];
};

